import script from "./RoleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleModal.vue?vue&type=script&setup=true&lang=js"

import "./RoleModal.vue?vue&type=style&index=0&id=639f7e20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-639f7e20"]])

export default __exports__